export const CHAT_SET_ROOMS = 'CHAT_SET_ROOMS'    // получение всех комнат
export const CHAT_SET_ROOM = 'CHAT_SET_ROOM'    // получение всех комнат
export const CHAT_CREATE_ROOM = 'CHAT_CREATE_ROOM'  // запись новой комнаты
export const CHAT_PUSH_ROOM = 'CHAT_PUSH_ROOM'  // добавление новой комнаты
export const CHAT_REMOVE_ROOM = 'CHAT_REMOVE_ROOM'  // удаление комнаты

export const CHAT_SET_MESSAGES = 'CHAT_SET_MESSAGES' // получение всех сообщений в комнате
export const CHAT_PUSH_MESSAGE = 'CHAT_PUSH_MESSAGE' // добавление нового сообщения в список чата